
<v-container class="step-container" v-if="unit && current">
    <c-drop-message
        v-if     = "drag.notAllowed"
        :message ="drag.message"
    />

    <drop class="cut" @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
        <v-row class="no-frame">
            <v-col class="step-first-column">
                <inc-status
                    v-model = "current.status"
                    :items  = "step.status"
                    @change = "onStatusChanged"
                    :background = "fileEntryFieldBackground"
                    class   = "mt-6"
                />

                <v-row class="no-frame">
                    <v-col class="no-frame col-12">
                        <msd-users
                            v-model     = "incident.responsible"
                            :background = "fileEntryFieldBackground"
                        />
                    </v-col>
                </v-row>


                <c-v-spacer />
            </v-col>
            <v-col class="step-middle-column pa-0" style="border: none">
                <!-- Abstract of maintenance contract data -->
                <c-contract-mnt-abstract
                    v-if      = "data.tags.includes('contract')"
                    class      = "lm-border mt-0 mb-3"
                    :show-unit = "this.data.collection.length > 1"
                    style      = "height: 200px;"
                />
                <!-- Abstract of maintenance contract data -->

                <div class="lm-border pa-3" :style="data.tags.includes('contract') ? 'min-height: 478px' : 'min-height: 690px'">
                    <v-row class="no-frame">
                        <v-col class="no-frame col-6 pr-2">
                            <f-date-picker
                                label   = "inc.maintenance.exedate"
                                v-model = "data.executiondate"
                                :background-color = "fileEntryFieldBackground"
                                :rules  = "[requiredRule]"
                                class   = "w-100"
                                @change = "onExecutiondate"
                            />
                        </v-col>
                    </v-row>

                    <v-row class="no-frame mt-2" >
                        <inc-manufacturer
                            v-model     = "data.manufacturer"
                            :rules      = "[requiredComboRule]"
                            :background = "fileEntryFieldBackground"
                            @changed    = "onManufacturer"
                        />
                    </v-row>

                    <v-row class="no-frame">
                        <v-col class="no-frame col-12">
                            <v-text-field
                                label="Servicetechniker"
                                v-model="data.technician"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                :background-color="fileEntryFieldBackground"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                    </v-row>


                    <v-row class="no-frame">
                        <v-col class="no-frame col-6 pr-2">
                            <v-text-field
                                label          = "Vertragsnummer"
                                v-model        = "data.contractNo"
                                :readonly      = "readonly"
                                :disabled      = "readonly"
                                :background-color="fileEntryFieldBackground"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                            />
                        </v-col>
                        <v-col class="no-frame col-6 pl-2">
                            <v-text-field
                                label             = "Auftragsnummer"
                                v-model           = "data.orderNo"
                                :readonly         = "readonly"
                                :disabled         = "readonly"
                                :background-color = "fileEntryFieldBackground"
                                autocomplete      = "off"
                                autocorrect       = "off"
                                autocapitalize    = "off"
                                spellcheck        = "false"
                            />
                        </v-col>
                    </v-row>
                </div>
                <c-v-spacer />
            </v-col>
            <v-col class="step-middle-column">
                <v-textarea
                    v-model        = "current.description"
                    :label         = "$t('inc.edit.general.description')"
                    :rows          = "rows"
                    class          = "mt-4"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    no-resize
                    counter
                />
                <v-textarea
                    v-model        = "current.result"
                    label         = "Ergebnis"
                    :rows          = "rows"
                    class          = "mt-3"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    no-resize
                    counter
                />
                <c-v-spacer />
            </v-col>
            <v-col class="step-last-column" style="padding-right: 5px">
                <crm-journal
                    :incident = "incident"
                    @front    ="onJournalFront"
                    style     = "margin-top: -10px"
                />
            </v-col>
        </v-row>
    </drop>
</v-container>
